import { createFileRoute } from "@tanstack/react-router";
import Landing from "@/pages/Landing";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "De Hussel App – Slimme hussel- en toss-indelingen voor tennis & padel" },
      { name: "description", content: "Dé hussel- en toss-app voor tennisclubs. Slimme automatische baanindeling op basis van niveau, gespeelde rondes en tegenstanders. Geen vrijwilligers nodig!" },
      { property: "og:title", content: "De Hussel App – Slimme hussel- en toss-indelingen voor tennis & padel" },
      { property: "og:description", content: "Dé hussel- en toss-app voor tennisclubs. Slimme automatische baanindeling op basis van niveau, gespeelde rondes en tegenstanders. Geen vrijwilligers nodig!" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "De Hussel App – Slimme hussel- en toss-indelingen voor tennis & padel",
          description:
            "Dé hussel- en toss-app voor tennisclubs. Slimme automatische baanindeling op basis van niveau, gespeelde rondes en tegenstanders. Geen vrijwilligers nodig!",
          url: "https://dehusselapp.nl/",
          mainEntity: {
            "@type": "SoftwareApplication",
            name: "De Hussel App",
            applicationCategory: "SportsApplication",
            operatingSystem: "Web",
          },
        }),
      },
    ],
  }),
  component: Landing,
});
